/**
 * 错误拦截器：对所有接口请求返回的异常错误码进行统一的处理
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import routerConfig from '@/routes/router.config'
import { refreshResource } from 'apis/user'
import { message } from 'ant-design-vue'
var timeout
/**
 * 异常错误码统一处理
 *
 * @param {object} body - 响应体
 * @returns {object} -  返回false时，提前退出
 */
export default function abnormalErrorInterceptor(body) {
  const { data } = body

  // 异常处理后，如果需要再弹toast的，则返回true
  switch (data.code) {
    // 未登录时
    case 'A0317':
      // 刷新浏览器，清空单例树
      if (window.location.pathname != '/login') {
        setTimeout(() => {
          routerConfig.push('/login')
        }, 1000)
      }
      window.sessionStorage.removeItem('token')
      return true
    case 'A0316':
      // 刷新浏览器，清空单例树
      if (window.location.pathname != '/login') {
        setTimeout(() => {
          routerConfig.push('/login')
        }, 1000)
      }
      window.sessionStorage.removeItem('token')
      return true
    // 权限变更
    case 'A0327':
      // 刷新浏览器，清空单例树
      if (window.location.pathname != '/login') {
        if (!timeout) {
          timeout = setTimeout(() => {
            timeout = null
            refreshResource().then(() => {
              routerConfig.push('/')
              message.success('权限变更')
              setTimeout(() => {
                window.location.reload()
              }, 1500)
            })
          }, 500)
        }
      }
      return true
    default:
      return true
  }
}
